import * as React from 'react'

import { Redirect, Route, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app'
import { useAppRoutes } from '@webapp/hooks'
import { UnbilledItemsPageStatuses } from './types'
import { UnbilledItemsPage } from './UnbilledItemsPage'

export const UnbilledItemPageRouter = () => {
  const { brp, url } = useAppRoutes()

  return (
    <Switch>
      <ProtectedRoute
        path={brp('UnbilledItemsPage', { status: ':status' })}
        component={UnbilledItemsPage}
      />

      <Route
        path='*'
        render={() => (
          <Redirect
            to={url('UnbilledItemsPage', {
              status: UnbilledItemsPageStatuses.ACTIVE,
            })}
          />
        )}
      />
    </Switch>
  )
}
